/*
 * Copyright (c) 2019. Botanická zahrada Přírodovědecké fakulty Univerzity Karlovy, Juraj Šimon
 */

import Vue from "./init";
import Router from "vue-router";

Vue.use(Router);

const ROUTE_NAMES = {
  HOME: "home",
  SEARCH: "search",
  ARTICLE: "article",
  VISIT_US: "visit-us",
  EVENTS: "events",
  EXPOSITIONS: "expositions",
  TOURS: "tours",
  GARDEN_MAP: "garden-map",
  CONTACTS: "contacts",
  ARTICLES: "articles",
  NOTIFICATIONS: "notifications",
  NOTIFICATION: "notification",
  GALLERIES: "galleries",
  GALLERY: "gallery",
  IS_BLOOMING_GALLERY: "gallery_is_blooming"
};

const router = new Router({
  mode: "history",
  routes: [
    {
      path: "/",
      name: ROUTE_NAMES.HOME,
      component: () => import("./components/pages/home.vue"),
      meta: {
        crumbs: null
      }
    },
    {
      path: "/search",
      name: ROUTE_NAMES.SEARCH,
      component: () => import("./components/pages/search"),
      meta: {
        crumbs: [{ name: "home", label: "Home" }]
      }
    },
    {
      path: "/clanky",
      name: ROUTE_NAMES.ARTICLES,
      component: () => import("./components/pages/articles"),
      meta: {
        crumbs: [{ name: "home", label: "Home" }]
      }
    },
    {
      path: "/visit-us",
      name: ROUTE_NAMES.VISIT_US,
      component: () => import("./components/pages/visit-us"),
      meta: {
        crumbs: [{ name: "home", label: "Home" }]
      }
    },
    {
      path: "/contacts",
      name: ROUTE_NAMES.CONTACTS,
      component: () => import("./components/pages/contacts"),
      meta: {
        crumbs: [{ name: ROUTE_NAMES.HOME, label: "Home" }]
      }
    },
    {
      path: "/events",
      name: ROUTE_NAMES.EVENTS,
      component: () => import("./components/pages/events"),
      meta: {
        crumbs: [{ name: "home", label: "Home" }]
      }
    },
    {
      path: "/expositions",
      name: ROUTE_NAMES.EXPOSITIONS,
      component: () => import("./components/pages/expositions"),
      meta: {
        crumbs: [{ name: ROUTE_NAMES.HOME, label: "Home" }]
      }
    },
    {
      path: "/tours",
      name: ROUTE_NAMES.TOURS,
      component: () => import("./components/pages/tours"),
      meta: {
        crumbs: [{ name: ROUTE_NAMES.HOME, label: "Home" }]
      }
    },
    {
      path: "/garden-map",
      name: ROUTE_NAMES.GARDEN_MAP,
      component: () => import("./components/pages/garden-map"),
      meta: {
        scrollToTop: true,
        crumbs: [{ name: "home", label: "Home" }]
      }
    },
    {
      path: "/clanky/:idOrName",
      name: ROUTE_NAMES.ARTICLE,
      component: () => import("./components/pages/article"),
      meta: {
        crumbs: [
          { name: "home", label: "Home" },
          { name: "articles", label: "Articles" }
        ]
      }
    },
    {
      path: "/galleries",
      name: ROUTE_NAMES.GALLERIES,
      component: () => import("./components/pages/galleries"),
      meta: {
        scrollToTop: true,
        crumbs: [{ name: "home", label: "Home" }]
      }
    },
    {
      path: "/gallery/:id",
      name: ROUTE_NAMES.GALLERY,
      component: () => import("./components/pages/gallery"),
      meta: {
        crumbs: [
          { name: ROUTE_NAMES.HOME, label: "Home" },
          { name: ROUTE_NAMES.GALLERIES, label: "All galleries" }
        ]
      }
    },
    {
      path: "/galleries/blooming",
      name: ROUTE_NAMES.IS_BLOOMING_GALLERY,
      component: () => import("./components/pages/blooming"),
      meta: {
        crumbs: [
          { name: "home", label: "Home" },
          { name: ROUTE_NAMES.GALLERIES, label: "All galleries" }
        ]
      }
    },
    {
      path: "/notifications",
      name: ROUTE_NAMES.NOTIFICATIONS,
      component: () => import("./components/pages/notifications"),
      meta: {
        crumbs: [{ name: "home", label: "Home" }]
      }
    },
    {
      path: "/notifications/:idOrName",
      name: ROUTE_NAMES.NOTIFICATION,
      component: () => import("./components/pages/article"),
      meta: {
        crumbs: [
          { name: "home", label: "Home" },
          { name: "notifications", label: "Notifications" }
        ]
      }
    }
  ]
});

export { ROUTE_NAMES };

export default router;
